module.exports = __webpack_public_path__ + "img/gedung.932f6a7c.jpg";